export const VIDEO_APP_PROXY_PATH = '/video';